import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FeedbackComponent } from "./components/feedback/feedback.component";
import { JobOfferFeedbackComponent } from "./components/job-offer-feedback/job-offer-feedback.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RatingModule } from "ngx-bootstrap";

@NgModule({
  declarations: [FeedbackComponent, JobOfferFeedbackComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RatingModule.forRoot(),
  ],
  entryComponents: [FeedbackComponent],
})
export class FeedbackModule {}
